import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import LogoutIcon from "@mui/icons-material/Logout";
import { Outlet, useNavigate } from "react-router-dom";
import ModalForm from "./dashboard/addModal/ModalForm";
import DI from "../utility/DI";
import Footer from "../utility/Footer";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Avatar, Chip } from "@mui/material";
import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import Navigators from "../Navigators";
import { environment } from "../../Env_data/environment";
import { AppContext } from "../../App";

export const FetchContext = React.createContext(false);
function stringToColor(number) {
  let hash = 0;

  /* eslint-disable no-bitwise */
  hash = number & 0xffffffff;
  hash = ((hash >> 16) ^ hash) * 0x45d9f3b;
  hash = ((hash >> 16) ^ hash) * 0x45d9f3b;
  hash = (hash >> 16) ^ hash;
  /* eslint-enable no-bitwise */

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name}`,
  };
}
function ResponsiveAppBar(props) {
  const {
    mode,
    setMode,
    banner,
    hideBanner,
    di: { session, logout, success, GET, urls, error },
  } = props;
  const [refresh, setRefresh] = React.useState(false);
  const navigate = useNavigate();
  const { APP_NAME } = environment;
  const {state}=React.useContext(AppContext)


  React.useEffect(() => {
    GET(urls.get.input_suggestions)
      .then((res) => {
        if (res.success) {
              if (session && Object.keys(session).length > 0)
                localStorage.setItem(APP_NAME+'_suggestions', JSON.stringify(res.suggestions));
        } else {
          error(res.message);
        }
      })
      .catch((err) => {
        error("Failed to fetch suggestions");
      });
  }, []);

  return (
    <FetchContext.Provider value={{ refresh, setRefresh }}>
      <AppBar position="sticky" >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}
              onClick={() => navigate("/panel/about")}
            >
              <div style={{ width: "100px", padding: "10px" }}>
                <img
                  style={{ width: "100%" }}
                  src={"/white_logo.png"}
                  alt={"spent_app"}
                  loading="lazy"
                />
              </div>
            </Box>
            <Box
              sx={{ display: { md: "none" }, mr: 1 }}
              onClick={() => navigate("/panel/about")}
            >
              <div style={{ width: "80px", padding: "10px" }}>
                <img
                  style={{ width: "100%" }}
                  src={"/white_logo.png"}
                  alt={"spent_app"}
                  loading="lazy"
                />
              </div>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: {
                  xs: "flex",
                  borderLeft: "2px solid white",
                  paddingLeft: "20px",
                },
              }}
            >
              {
                session?.id&&<Avatar {...stringAvatar(session.id)} />
              }
              
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <IconButton
                style={{ transform: refresh ? "rotate(180deg)" : "" }}
                onClick={() => setRefresh((prev) => !prev)}
              >
                <RefreshIcon sx={{ color: "white" }} />
              </IconButton>
              <IconButton
                sx={{ ml: 1 }}
                onClick={() => setMode(mode == "dark" ? "light" : "dark")}
                color="inherit"
              >
                {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
              <IconButton onClick={logout}>
                <LogoutIcon sx={{ color: "white" }} />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Box
        disableGutters
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        <Toolbar />
        <div style={{ maxWidth: "100vw" }}>
          <Container maxWidth="lg" sx={{ mt: 1, mb: 4 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "calc(100vh - 160px)",
                gap:'15px'
              }}
            >
              {banner && (
                <Chip
                  color="primary"
                  onDelete={hideBanner}
                  variant="outlined"
                  label="Add to Home Screen this page from browser settings."
                  icon={<AppShortcutIcon />}
                />
              )}
              <div>
              <Navigators/>
                <Outlet />
              </div>
              <Footer />
            </div>
          </Container>
        </div>
        <ModalForm />
      </Box>
    </FetchContext.Provider>
  );
}

export default DI(ResponsiveAppBar);
